/**
 * Date Utilities
 * Re-exports date-fns functions for consistent date handling
 */

export {
  format,
  formatDistance,
  formatRelative,
  parseISO,
  isValid,
  isBefore,
  isAfter,
  addDays,
  subDays,
  addWeeks,
  subWeeks,
  addMonths,
  subMonths,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
  differenceInYears,
} from 'date-fns'

/**
 * The SPCC business day: a full 00:00 → 00:00 Riyadh day (AST = UTC+3, no DST).
 *
 * Date presets ("today", "yesterday", …) must resolve against the Riyadh day,
 * not the viewer's calendar day: a browser outside KSA has a different calendar
 * date. The backend windows every dashboard on this same boundary
 * (apps/strapi/src/utils/working-day.ts).
 */
const KSA_OFFSET_MS = 3 * 60 * 60 * 1000

/**
 * The Riyadh day containing `now`, as a noon-UTC Date — safe to feed to
 * date-fns `startOfWeek`/`addDays`/etc without a DST or timezone fold.
 */
export function workingDayAnchor(now: Date = new Date()): Date {
  const ksa = new Date(now.getTime() + KSA_OFFSET_MS)
  return new Date(Date.UTC(ksa.getUTCFullYear(), ksa.getUTCMonth(), ksa.getUTCDate(), 12))
}

/** `YYYY-MM-DD` key of a Riyadh-day anchor (or of any noon-UTC date). */
export function workingDayKey(anchor: Date): string {
  return anchor.toISOString().slice(0, 10)
}
